import UserError from './UserError.js'

export class UploadAttachmentUserError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new UploadAttachmentUserError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
